import { useEffect } from 'react';
import { IniciadoAutorizadoTotalesSection } from './IniciadoAutorizadoTotalesSection';
import { IniciadoAutorizadoSection } from './IniciadoAutorizadoSection';
import { useProtesisIniciadoAutorizadoData } from '../hooks';

const initData = {
  // idDivision: 5,
  // idTipoCobertura: 166,
};

export const ProtesisTramitesIniciadoAutorizado = () => {
  const { getProtesisTramitesAnualList, getProtesisTramitesMensualList } =
    useProtesisIniciadoAutorizadoData({
      ...initData,
    });

  useEffect(() => {
    getProtesisTramitesAnualList();
    getProtesisTramitesMensualList();
  }, []);

  return (
    <>
      <IniciadoAutorizadoTotalesSection />
      <IniciadoAutorizadoSection />
    </>
  );
};
